/**
 * Catalog taxable flag. Explicit false / 0 / "0" / "false" stay non-taxable.
 * Null or blank uses defaultValue (true) so unset FFLBoss products are taxed.
 */
export function catalogTaxable(value, defaultValue = true) {
	if (value === true || value === 1 || value === '1' || value === 'true') {
		return true;
	}
	if (value === false || value === 0 || value === '0' || value === 'false') {
		return false;
	}
	if (value == null || value === '') {
		return defaultValue;
	}
	return !!value;
}

export function fflCatalogTaxable(value, forceTaxable, defaultValue = true) {
	if (forceTaxable) {
		return true;
	}
	return catalogTaxable(value, defaultValue);
}
